<template>
  <div>
    <div class="popup" v-show="visible" @click="hide()" :style="popupStyle"></div>
    <transition :name="'slide-' + position" appear>
      <div :class="popupClass" v-show="visible" :style="popupStyle">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'popup',
  data () {
    return {
      visible: false
    }
  },
  props: {
    position: {
      type: String,
      default: 'bottom'
    },
    popupStyle: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    popupClass () {
      return 'popup-container ' + this.position
    }
  },
  methods: {
    show () {
      this.visible = true
      document.body.style.overflow = 'hidden'
      document.body.style.height = '100%'

      return new Promise(resolve => {
        this._resolve = resolve
      })
    },
    hide (arg) {
      this.visible = false
      document.body.style.overflow = 'auto'
      document.body.style.height = 'auto'

      this._resolve && this._resolve(arg)
      this._resolve = null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/popup.vue